export default "__VITE_ASSET__ced16937__"